import { instance } from '../../../axios/AxiosInstance';

const PATH = 'category';

function contentTypeForImageKey(key: string): string {
  const lower = key.toLowerCase();
  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.gif')) return 'image/gif';
  if (lower.endsWith('.webp')) return 'image/webp';
  return 'image/jpeg';
}

function buildCategoryImageObjectKey(categoryId: string, file: File): string {
  const safeId = categoryId.replace(/[^a-zA-Z0-9_-]/g, '');
  const raw = file.name.replace(/[^a-zA-Z0-9._-]+/g, '_').replace(/^\.+/, '');
  const base = raw || 'image';
  return `category/${safeId}/${base}`;
}

export async function requestPresignedPutUrl(key: string): Promise<string> {
  const { data } = await instance.post<{ uploadUrl?: string }>('s3', { key });
  if (!data?.uploadUrl) {
    throw new Error('Presign response missing uploadUrl');
  }
  return data.uploadUrl;
}

export async function putFileToS3(uploadUrl: string, file: File, contentType: string): Promise<void> {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': contentType },
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}

/** Uploads to `category/{categoryId}/…` in the data bucket; returns the S3 object key. */
export async function uploadCategoryImageFile(categoryId: string, file: File): Promise<string> {
  const key = buildCategoryImageObjectKey(categoryId, file);
  const contentType = contentTypeForImageKey(key);
  const uploadUrl = await requestPresignedPutUrl(key);
  await putFileToS3(uploadUrl, file, contentType);
  return key;
}

export type CreatedCategory = { id: string };

export async function createCategory(body: Record<string, unknown>): Promise<CreatedCategory> {
  const { data } = await instance.post<{ data?: { id?: string } }>(PATH, body);
  const id = data?.data?.id;
  if (!id) {
    throw new Error('Категори үүсгэхэд ID ирсэнгүй.');
  }
  return { id };
}

export async function updateCategory(body: Record<string, unknown>): Promise<void> {
  await instance.put(PATH, body);
}
